export const SHOW_PAYWALL = 'SHOW_PAYWALL';
export const HIDE_PAYWALL = 'HIDE_PAYWALL';
export const SET_PAYWALL = 'SET_PAYWALL';